import { render, staticRenderFns } from "./reasonForCulling.vue?vue&type=template&id=5e9e6536&scoped=true&"
import script from "./reasonForCulling.vue?vue&type=script&lang=js&"
export * from "./reasonForCulling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9e6536",
  null
  
)

export default component.exports